import React from 'react';

const TemplatePanel = ({ record }) => {
    return <div dangerouslySetInnerHTML={{ __html: record.content }} />;
};

export default TemplatePanel;
